import {
  applyMiddleware,
  createStore as createReduxStore,
  compose
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';

import { getStorage, setStorage } from 'utilz';
import { initialState as phoneInitialState } from 'pages/Phone/reducer';

import reducer from './reducer';
import mainSaga from './saga';
// import defaultState from './defaultState';

const createStore = () => {
  const history = createHistory();
  const saga = createSagaMiddleware();

  const middleware = [routerMiddleware(history), saga];

  let composeEnhancers = compose;

  if (
    process.env.NODE_ENV === 'development' &&
    // eslint-disable-next-line
    typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
  ) {
    // eslint-disable-next-line
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }

  if (Object.keys(getStorage()).length === 0) {
    setStorage();
  }
  /*
    Втрачаємо номер телефона після перегрузки можна фіксанути на фронті і на бекенді

  */
  const data = {
    phone: { ...phoneInitialState, ...getStorage().phone },
    user: getStorage().user || { user: {} }
  };

  // console.log(defaultState());

  const store = createReduxStore(
    reducer,
    { ...getStorage(), ...data },
    composeEnhancers(applyMiddleware(...middleware))
  );

  saga.run(mainSaga);

  return {
    store,
    history
  };
};

export default createStore;



// WEBPACK FOOTER //
// ./src/store/createStore.js